/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';
import { now, today } from '@internationalized/date';

export const DivisionProps = PropTypes.shape({
    starts_at: PropTypes.string,
    ends_at: PropTypes.string,
    price: PropTypes.number,
    display_price: PropTypes.string,
    name: PropTypes.string,
});

export const PricingPeriodProps = PropTypes.shape({
    start_date: PropTypes.string,
    divisions: PropTypes.arrayOf(DivisionProps),
});

export const DivisionDefaults = {
    starts_at: '01-01',
    ends_at: '12-31',
    price: 0,
    display_price: '0',
    name: '',
};

export const PricingPeriodDefaults = [
    {
        start_date: today().subtract({ years: 10 }).toString(),
        divisions: [],
    },
];
